export default "__VITE_ASSET__4d6b9c90__"